import React, { Component } from "react";
import Btn from "../../../Components/Btn";

const citiesData = [
  {
    code: "CAI",
    name: "Cairo",
    stations: ["Down Town" , "Almaza"],
  },
  {
    code: "ALX",
    name: "Alexandria",
    stations: ["Down Town" , "station 1"],
  },
  {
    code: "HRG",
    name: "Hurghada",
    stations: ["station 1" , "station 2"],
  },
  {
    code: "SSH",
    name: "Sharm El Sheikh",
    stations: ["station 1" , "station 2"],
  },
];

export default class CitiesTable extends Component {

  render() {
    let cities = [];
    citiesData.forEach(city => {
        cities.push(
            <tr>
              <td>{city.code}</td>
              <td><div className="nowrap">{city.name}</div></td>
              <td><div className="nowrap">{city.stations}</div></td>
              <td className="text-right">
                <div className="actions">
                  <Btn className="btn unstyled"><img src="/imgs/icons/sort.png" alt="sort icon" width="17"/></Btn>
                  <Btn className="btn simple">edit</Btn>
                </div>
              </td>
            </tr>
        )
    });
    return (
      <table className="basic-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>City</th>
            <th>Stations</th>
            <th></th>
          </tr>
        </thead>
        <tbody>{cities}</tbody>
      </table>
    );
  }
}
